const Modal = {
  state: {
    modalError: false,
    dataModalError: '',
    modalResultSurvey: {
      active: false,
      gameId: null,
      teamId: null
    }
  },
  actions: {
    closeModalError: ({commit}) => {
      commit("SET_modalError", false)
    },
    openModalError: ({commit}, data) => {
      if (data != undefined) commit("SET_dataModalError", data)
      commit("SET_modalError", true)
    },
    closeModalResultSurvey: ({commit}) => {
      commit("SET_modalResultSurvey", {active: false, gameId: null, teamId: null})
    },
    openModalResultSurvet: ({commit}, params) => {
      commit("SET_modalResultSurvey", params)
    }
  },
  mutations: {
    SET_modalError (state, value) {
      state.modalError = value
    },
    SET_modalResultSurvey (state, params) {
      state.modalResultSurvey = params
    },
    SET_dataModalError (state, data) {
      state.dataModalError = data
    }
  }
};

export default Modal;